export { slackServiceFactory } from './slackServiceFactory';
export { isAtlassianSlackProduct } from './types';
export { FetchError } from './util';
export type { SlackService } from './SlackService';
export type { AtlassianSlackProduct } from './types';
export type {
	IsSlackEnabledResult,
	GetSlackConsentUrlResult,
	SlackUser,
	ShareToSlackProps,
} from './share-to-slack/common/types';

import PlatformSlackService from './PlatformSlackService';
import ShareToSlack from './share-to-slack/ui';

export { PlatformSlackService };

export default ShareToSlack;
